import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { changePassword } from '../../api/client';

export default function ChangePassword() {
  const navigate = useNavigate();
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const stored = localStorage.getItem('user');
  const user = stored ? JSON.parse(stored) : null;
  const tempPw = sessionStorage.getItem('tempPw');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (newPw !== confirmPw) {
      setError('New passwords do not match');
      return;
    }
    if (!tempPw) {
      setError('Session expired. Please log in again.');
      return;
    }
    setLoading(true);
    try {
      await changePassword(tempPw, newPw);
      sessionStorage.removeItem('tempPw');
      if (user) {
        user.mustChangePassword = false;
        localStorage.setItem('user', JSON.stringify(user));
      }
      if (user?.role === 'CLIENT' && user?.clientId) {
        localStorage.setItem('activeClient', JSON.stringify({ id: user.clientId, name: user.name }));
        navigate('/dashboard');
      } else {
        navigate('/clients');
      }
    } catch (err) {
      setError(err.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/bcd-icon.png" alt="BCD" className="h-10 mx-auto mb-3" />
          <h1 className="text-2xl font-heading font-bold text-white uppercase tracking-wide">
            Set Your Password
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <p className="text-sm text-txt-secondary mb-4">
            Please choose a personal password before continuing.
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="password"
              placeholder="New password (12+ characters)"
              value={newPw}
              onChange={(e) => setNewPw(e.target.value)}
              required
              autoFocus
              className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-gold"
            />
            <input
              type="password"
              placeholder="Confirm new password"
              value={confirmPw}
              onChange={(e) => setConfirmPw(e.target.value)}
              required
              className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-gold"
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}
            <p className="text-xs text-gray-500">
              12+ characters. Must include uppercase, lowercase, number, and special character.
            </p>
            <button
              type="submit"
              disabled={loading}
              className="btn-gold w-full py-3 text-sm font-semibold disabled:opacity-50"
            >
              {loading ? 'Updating...' : 'Set Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
